import React from 'react';
import { useLocation } from 'react-router-dom';
import { FormattedMessageWrappedInSpan } from '../../misc';

const InvalidGpxFileInformation = () => {
  const location = useLocation();

  const isStravaSearch = location.pathname.includes('/strava/');

  return (
    <div className="row">
      <div className="col-xs-16 col-sm-12 col-sm-offset-2">
        <div className="notification-info">
          <h2>
            {isStravaSearch ? (
              <FormattedMessageWrappedInSpan
                id="invalidGpxFileInformation.strava.message"
                defaultMessage="We could not find any photos with the Strava activity you provided. Please make sure it corresponds to the correct EVENT."
              />
            ) : (
              <FormattedMessageWrappedInSpan
                id="invalidGpxFileInformation.manual.message"
                defaultMessage="We could not find any photos with the gpx file you provided. Please make sure the gpx file corresponds to the correct EVENT."
              />
            )}
          </h2>
        </div>
      </div>
    </div>
  );
};

export default InvalidGpxFileInformation;
